/**
 * Open a WhatsApp chat with a pre-filled message.
 *
 * Why a helper? Inside iframed preview environments (and some browsers with
 * COOP=same-origin) plain <a target="_blank"> links to wa.me get rejected with
 * ERR_BLOCKED_BY_RESPONSE.NotSameOrigin. Using `window.open` with
 * `noopener,noreferrer` works around that because the new context is fully
 * detached.
 *
 * Phone must be a digits-only string in E.164 without `+` (e.g. 573045729333).
 */
export function openWhatsApp(phone, message = "") {
  const digits = String(phone || "").replace(/[^0-9]/g, "");
  if (!digits) return;
  const url = `https://wa.me/${digits}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
  const win = window.open(url, "_blank", "noopener,noreferrer");
  // Fallback: if popups are blocked, navigate the top-level window so the link still works.
  if (!win || win.closed || typeof win.closed === "undefined") {
    try {
      window.top.location.href = url;
    } catch {
      window.location.href = url;
    }
  }
}

/**
 * Same as `openWhatsApp` but returns the URL string for cases where we still
 * want to render an actual <a href> (e.g. so right-click → "open in new tab"
 * works). Use together with `onClick={(e) => { e.preventDefault(); openWhatsApp(...) }}`.
 */
export function whatsappUrl(phone, message = "") {
  const digits = String(phone || "").replace(/[^0-9]/g, "");
  if (!digits) return "#";
  return `https://wa.me/${digits}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
}
